var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPwCFunctIconsCircleDeleteFillBlackRgb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 104 99",
    style: {
      enableBackground: "new 0 0 104 99"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#DB536A;}\r\n\t.st2{fill:#7D7D7D;}\r\n\t.st3{fill:#D04A02;}\r\n\t.st4{fill:#E0301E;}\r\n\t.st5{fill:#464646;}\r\n\t.st6{fill:#2D2D2D;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill-v2_14_",
    d: "M52,13.5c-19.9,0-36,16.1-36,36s16.1,36,36,36c19.9,0,36-16.1,36-36S71.9,13.5,52,13.5z M69.6,60.8 l-6.4,6.4L52,55.9L40.8,67.1l-6.4-6.4l11.3-11.3L34.4,38.3l6.4-6.4L52,43.1l11.3-11.3l6.4,6.4L58.4,49.5L69.6,60.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwCFunctIconsCircleDeleteFillBlackRgb);
export default __webpack_public_path__ + "static/media/PwC_Funct_Icons_CircleDelete_Fill_Black_RGB.e519424930d7a782eb3ba656e61f8611.svg";
export { ForwardRef as ReactComponent };